export const actionsDacState = {
    copySites: [],
    copyServices: []
}

